// export const openInNewTab = (url) => {
//   const newWindow = window.open(url, "_blank", "noopener,noreferrer");
//   if (newWindow) newWindow.opener = null;
// };

import { appendUTMParameters } from "../utils/appendUTMParameters";

export const CART_STORAGE_KEY = "cart_cnmap";

export const addCnmapToCart = () => {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(
      CART_STORAGE_KEY,
      JSON.stringify({
        state: {
          products: [
            {
              id: 57,
              productId: 52,
              name: "The Certified Nurse Medical Affairs Professional (CNMAP™) Program",
              nickname: "cnmap",
              type: "learningPlan",
              price: 649.0,
            },
          ],
        },
        version: 0,
      })
    );
    window.dispatchEvent(new Event("cnmap-cart-updated"));
  } catch {
    // ignore storage errors
  }
};

export const clearCnmapCart = () => {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(
      CART_STORAGE_KEY,
      JSON.stringify({
        state: { products: [] },
        version: 0,
      })
    );
    window.dispatchEvent(new Event("cnmap-cart-updated"));
  } catch {
    // ignore storage errors
  }
};

export const openInNewTab = (url) => {
  if (!url) return;
  if (url.startsWith("/")) {
    if (url.startsWith("/checkout")) {
      addCnmapToCart();
    }
    window.location.assign(url);
    return;
  }
  const urlWithUTMs = appendUTMParameters(url);
  const newWindow = window.open(urlWithUTMs, "_blank", "noopener,noreferrer");
  if (newWindow) newWindow.opener = null;
};
